export const endpoints = {
  getInterventionTag: '/occurrence/intervention/tag',
}
